import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { black, orange2 } from '../../styles/colors';

const AnchorLink = styled.a.attrs({
  target: props => props.newTab ? '_blank' : '',
  rel: props => props.newTab ? 'noopener noreferrer' : '',
  title: props => props.title || '',
})`
  cursor: pointer;
  font-weight: bold;
  color: ${black};
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  &:hover {
    color: ${orange2};
  }
  &:focus {
    outline: ${black} dotted 2px;
  }
`;

export const AnchorLinkDisabled = styled.a`
  font-weight: bold;
  color: ${black};
  text-decoration: none !important; 
  pointer-event: none !important;
  :hover {
    color: ${black};
    text-decoration: none !important;
    pointer-event: none !important;
  }
`;

const OLink = ({
  children, id, underline, onClick, href, disabled, newTab, shouldBeHidden, title
}) => {
  if (disabled || shouldBeHidden) {
    return (
      <AnchorLinkDisabled className={shouldBeHidden ? 'hidden' : ''} id={id} underline={false} title={title}>
        {children}
      </AnchorLinkDisabled>
    );
  }

  return (
    <AnchorLink id={id} newTab={newTab} href={href} onClick={onClick} underline={underline} title={title}>
      {children}
    </AnchorLink>
  );
};

OLink.defaultProps = {
  onClick: undefined,
  href: 'javascript:void(0);', // eslint-disable-line no-script-url
  underline: true,
  disabled: false,
  newTab: false,
  shouldBeHidden: false,
  title: '',
};

OLink.propTypes = {
  /** Callback function onClick */
  onClick: PropTypes.func,
  /** String url anchor */
  href: PropTypes.string,
  /** Node inside the link */
  children: PropTypes.node.isRequired,
  /** String DOM identifier */
  id: PropTypes.string.isRequired,
  /** Boolean underline text-decoration */
  underline: PropTypes.bool,
  /** Boolean to know if he link should be disabled */
  disabled: PropTypes.bool,
  /** Boolean to know if the link must be open in a new tab */
  newTab: PropTypes.bool,
  /** Boolean to know if the component should be hidden */
  shouldBeHidden: PropTypes.bool,
  /** Title attribute */
  title: PropTypes.string,
};

export default OLink;
